// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1fNwB","signatureBlock":"Footer_signatureBlock__zpHkF","signature":"Footer_signature__3lKZX"};